export default "__VITE_ASSET__BmOzgW_m__"